<template>
    <ResponsiveDialog
        :value="value"
        @input="$emit('input', $event)"
        max-width="700"
        color="warning"
        :header-title="trainer ? trainer.fullName : ''"
        header-class="skin-window-header--trainerdetail"
        card-class="skin-card"
    >
        <TrainerList v-if="trainer" :trainer="trainer"/>
    </ResponsiveDialog>
</template>

<script>
    import ResponsiveDialog from "@/components/utils/ResponsiveDialog";
    import TrainerList from "@/components/trainer/TrainerList";

    export default {
        name: 'TrainerDetailPopup',
        components: {ResponsiveDialog, TrainerList},
        props: {
            value: {type: Boolean, default: false},
            trainer: {type: Object, default: null},
        },
    }
</script>
